<app-textarea-control
	[label]="label()"
	[controlName]="controlName()"
	[placeholder]="placeholder()"
	[required]="required()"
	[minLength]="minLength()"
	[rows]="rows()"
	[formGroup]="formGroup()"
/>
